import React from 'react';

const YodelChevron = ({className = "", isInPost = false}) => {
  return(
    <>
      {isInPost ?
        <svg className={`${className}`} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.99999 5.17296L11.95 0.222961L13.364 1.63696L6.99999 8.00096L0.635986 1.63696L2.04999 0.222961L6.99999 5.17296Z" fill="#1D1D1D"/>
        </svg>
      :
        <svg className={`${className}`} xmlns="http://www.w3.org/2000/svg" width="13.24" height="19.67" viewBox="0 0 13.24 19.67">
          <path id="angle-right" d="M13.24,9.849,2.282,19.67,0,17.654l8.709-7.8L0,2.045,2.282,0Z" fill="#767676"/>
        </svg>
      }
    </>
  )
};

export default YodelChevron;
